import React from 'react'

const Google = props => (
  <svg viewBox="0 0 36 28" {...props}>
    <path d="M22.453 14.266c0 6.547-4.391 11.188-11 11.188C5.125 25.454 0 20.329 0 14.001S5.125 2.548 11.453 2.548c3.094 0 5.672 1.125 7.672 3l-3.109 2.984c-.844-.812-2.328-1.766-4.562-1.766C7.548 6.766 4.36 10 4.36 14s3.187 7.234 7.094 7.234c4.531 0 6.234-3.266 6.5-4.937h-6.5v-3.938h10.813c.109.578.187 1.156.187 1.906zM36 12.359v3.281h-3.266v3.266h-3.281V15.64h-3.266v-3.281h3.266V9.093h3.281v3.266H36z" />
  </svg>
)

export default Google



// WEBPACK FOOTER //
// ./src/components/Icons/Google.js